module.exports = __webpack_public_path__ + "img/celine.5ab889e4.png";